var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { errors } from '@feathersjs/client';
import * as Raven from 'raven-js';
import { feathersServices } from 'src/feathers';
import Form from 'antd/lib/form';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import ButtonSubmit from 'src/pages/components/forms/ButtonSubmit';
var formStyles = require('src/imports/styles/extend.form.scss');
var FormAthleteScoreRouteHistory = (function (_super) {
    __extends(FormAthleteScoreRouteHistory, _super);
    function FormAthleteScoreRouteHistory(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
        };
        _this.handleSubmitForm = _this.handleSubmitForm.bind(_this);
        return _this;
    }
    FormAthleteScoreRouteHistory.prototype.componentWillReceiveProps = function (nextProps) {
        var currDoc = this.props.athleteScoreRouteHistory;
        var nextDoc = nextProps.athleteScoreRouteHistory;
        if (currDoc.id !== nextDoc.id) {
            this.props.form.resetFields();
        }
    };
    FormAthleteScoreRouteHistory.prototype.handleSubmitForm = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var formValues, sRHE, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.setState({ isFetching: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, new Promise(function (resolve, reject) {
                                _this.props.form.validateFieldsAndScroll({ scroll: { offsetTop: 96 } }, function (err, res) {
                                    if (err) {
                                        reject(err);
                                    }
                                    if (!err) {
                                        resolve(res);
                                    }
                                });
                            })];
                    case 2:
                        formValues = _a.sent();
                        sRHE = {
                            isOverwrite: true,
                            sequenceNumber: Date.now(),
                            submittedString: formValues.scoreString,
                            userId: this.props.userProfile.userId,
                            userName: this.props.userProfile.name,
                            userToken: localStorage['crimp-jwt'],
                            createdAt: (new Date()).toISOString(),
                        };
                        return [4, this.props.handlePatchAthleteScoreRouteHistory({
                                id: this.props.athleteScoreRouteHistory.id,
                                eventId: this.props.athleteScoreRouteHistory.eventId,
                                history: [sRHE],
                            })];
                    case 3:
                        response = _a.sent();
                        if (response.action.type === feathersServices.athleteScoreRouteHistories.types.SERVICES_ATHLETESCOREROUTEHISTORIES_PATCH_FULFILLED) {
                            this.setState({ isFetching: false });
                            message.success('Score was successfully saved!');
                        }
                        else {
                            throw new errors.GeneralError('Athlete was not saved');
                        }
                        return [3, 5];
                    case 4:
                        err_1 = _a.sent();
                        this.setState({ isFetching: false });
                        Raven.captureException(err_1);
                        if (err_1.message) {
                            message.error(err_1.message);
                        }
                        else {
                            message.error('There are several errors in your data. Please correct them');
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    FormAthleteScoreRouteHistory.prototype.render = function () {
        return (React.createElement(Form, { className: formStyles.form, hideRequiredMark: true, onSubmit: this.handleSubmitForm },
            React.createElement(Form.Item, { label: React.createElement("span", null, "Raw Score"), colon: false, extra: 'Add a comma \",\" between each attempt (e.g. 1,Z,1,Z,T)' }, this.props.form.getFieldDecorator('scoreString', {
                initialValue: this.props.athleteScoreRouteHistory.scoreString || '',
                rules: [{
                        max: 255,
                        message: 'Score is too long',
                    }, {
                        type: 'string',
                    }, {
                        whitespace: true,
                    }],
            })(React.createElement(Input, { size: 'large', autoComplete: 'off', disabled: this.state.isFetching }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Form.Item, null,
                        React.createElement(ButtonSubmit, { width: '100%', isFetching: this.state.isFetching }))))));
    };
    return FormAthleteScoreRouteHistory;
}(React.Component));
export default Form.create()(FormAthleteScoreRouteHistory);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormTeamAthleteScore/FormAthleteScoreRouteHistory/FormScoreString.tsx
// module id = 969
// module chunks = 0